import React, { useState } from "react";

const LayerControlPanel = ({ groups, toggleLayer }) => {
  const [expandedGroups, setExpandedGroups] = useState(() =>
    groups.reduce((acc, group) => {
      acc[group.title] = false; // all collapsed initially
      return acc;
    }, {})
  );

  const [searchTerm, setSearchTerm] = useState("");

  const toggleGroupExpand = (title) => {
    setExpandedGroups((prev) => ({
      ...prev,
      [title]: !prev[title],
    }));
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());
  };

  const handleGroupCheckboxChange = (e, group) => {
    const shouldShow = e.target.checked;
    group.sublayers.forEach((sublayer) => {
      toggleLayer(group.title, sublayer.id, shouldShow); // pass desired visibility
    });
  };

  return (
    <div
      style={{
        width: "100%",
        height: "calc(100vh - 300px)",
        overflowY: "auto",
        borderRight: "1px solid #e0e0e0",
        padding: "1rem",
        background: "#f7f9fb",
        fontFamily: "Segoe UI, Arial, sans-serif",
        fontSize: "14px",
      }}
    >
      <input
        type="text"
        placeholder="Search Layers..."
        onChange={handleSearchChange}
        style={{
          width: "100%",
          padding: "6px 10px",
          marginBottom: "1rem",
          borderRadius: "6px",
          border: "1px solid #ccc",
          outline: "none",
          fontSize: "13px",
          background: "#fff",
        }}
      />

      {groups.map((group) => {
        const filteredSublayers = group.sublayers.filter((sublayer) =>
          sublayer.title.toLowerCase().includes(searchTerm)
        );

        if (filteredSublayers.length === 0) return null;

        return (
          <div key={group.title} style={{ marginBottom: "1rem" }}>
            <div
              onClick={() => toggleGroupExpand(group.title)}
              style={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                fontWeight: "600",
                color: "#333",
                padding: "6px 8px",
                backgroundColor: "#e9f0f8",
                borderRadius: "4px",
              }}
            >
              {/* <input
                type="checkbox"
                checked={group.sublayers.every((sublayer) => sublayer.visible)}
                onChange={(e) => handleGroupCheckboxChange(e, group)}
                style={{ marginRight: "8px", opacity: 0.5 }}
              /> */}
              <span style={{ flex: 1 }}>{group.title}</span>
              <span
                style={{
                  fontSize: "20px",
                  color: "#2a3036ff",
                  fontWeight: "bold",
                }}
              >
                {expandedGroups[group.title] ? "▾" : "▸"}
              </span>
            </div>

            {expandedGroups[group.title] && (
              <div style={{ paddingLeft: "16px", marginTop: "6px" }}>
                {filteredSublayers.map((sublayer) => (
                  <div
                    key={sublayer.id}
                    style={{
                      marginBottom: "6px",
                      borderRadius: "4px",
                      padding: "6px 8px",
                      backgroundColor: sublayer.visible
                        ? "#d0eaff"
                        : "transparent",
                      transition: "background-color 0.2s ease",
                      cursor: "pointer",
                    }}
                    onClick={() => toggleLayer(group.title, sublayer.id)}
                  >
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        pointerEvents: "none",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={sublayer.visible}
                        readOnly
                        style={{
                          marginRight: "8px",
                          width: "16px",
                          height: "16px",
                        }}
                      />
                      <span style={{ fontSize: "13px" }}>{sublayer.title}</span>
                    </label>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default LayerControlPanel;
